import { User } from 'models/twilio';
import _isEmpty from 'lodash/isEmpty';

const safeUpdateIdleStatus = async (user: User, isIdle: boolean) => {
  if (user == null || _isEmpty(user?.attributes)) return;

  const currentAttributes = user.attributes;
  const updatedAttributes = { ...currentAttributes, isIdle };

  await user.updateAttributes(updatedAttributes);
};

export default safeUpdateIdleStatus;
